var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconrecommendationBox = function SvgIconrecommendationBox(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/reports/icon.recommendation_box") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/reports/icon.recommendation_box",
    stroke: "none",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.5, 0)",
    stroke: "#09BE86"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.0206, 4)",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 0.5,
    x2: 5.5,
    y2: 0.5,
    id: "Line"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 4.5,
    x2: 11.4683075,
    y2: 4.5,
    id: "Line-Copy"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 8.49964073,
    x2: 11.4683075,
    y2: 8.49964073,
    id: "Line-Copy-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 12.4992815,
    x2: 11.4683075,
    y2: 12.4992815,
    id: "Line-Copy-3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 16.4992815,
    x2: 11.4683075,
    y2: 16.4992815,
    id: "Line-Copy-4"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 2,
    x: 1,
    y: 1,
    width: 18,
    height: 23,
    rx: 3
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconrecommendationBox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.recommendation_box.0e4d4efd533778e1464243f5208eaa8b.svg";